import { render, staticRenderFns } from "./ItemRating.vue?vue&type=template&id=8812d9c4&scoped=true&"
import script from "./ItemRating.vue?vue&type=script&lang=js&"
export * from "./ItemRating.vue?vue&type=script&lang=js&"
import style0 from "./ItemRating.vue?vue&type=style&index=0&id=8812d9c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8812d9c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VRating})
